import {
    Box,
    Divider,
    Grid2,
    Snackbar,
    Stack,
    Typography,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
    useGetCourseMasterMutation,
    useGetUserInfoMutation,
    useGetClassCourseMappingListMutation,
    useGetTeacherClassMappingDetailListMutation,
} from "../../../apiSlice";
import { API_courseURL } from "../../../config";
import { useParentalInfoCheck } from "../../context/ParentalInfoCheck";
import SideBar from "./TeacherSidebar/TeacherSidebar";
import Navbar from "../../Header/header";
import Breadcrumb from "../../StudentBreadcrumb/Breadcrumb";

const CourseList = () => {
    const navigate = useNavigate();

    const [teacherData] = useState(() =>
        JSON.parse(localStorage.getItem("teacherInfo"))
    );
    useEffect(() => {
        console.log("teacherData >>>>> ", teacherData);
    }, [teacherData]);
    const [loading, setLoading] = useState(true);
    const [userData, setUserData] = useState();
    const [userClassList, setUserClassList] = useState();
    const [courseData, setCourseData] = useState([]);
    const [classCourseMappingList, setClassCourseMappingList] = useState([]);
    const [teacherCourseMappingList, setTeacherCourseMappingList] = useState(
        []
    );
    const [usableCourseLength, setUsableCourseLength] = useState(0);
    const [uniqueClassesForTeacher, setUniqueClassesForTeacher] = useState([]);
    const { isParentInfoPresent, snackbarOpen, setSnackbarOpen } =
        useParentalInfoCheck();

    function setCourseInternalData(course) {
        sessionStorage.setItem("courseData", JSON.stringify(course));
        navigate("/TeacherCourseDetails");
    }
    const [studentDataAPI] = useGetUserInfoMutation();
    const [studentCourseMasterAPI] = useGetCourseMasterMutation();
    const [classCourseMappingListAPI] = useGetClassCourseMappingListMutation();
    const [teacherClassMappingDetailListAPI] =
        useGetTeacherClassMappingDetailListMutation();

    useEffect(() => {
        const fetchMasters = async () => {
            if (loading) {
                try {
                    setLoading(true);

                    const courseMaster = await studentCourseMasterAPI();
                    setCourseData(courseMaster.data);

                    const studentData = await studentDataAPI();
                    setUserData(studentData.data);

                    // const classCourseMappingData =
                    //     await classCourseMappingListAPI();
                    // setClassCourseMappingList(classCourseMappingData.data);

                    const teacherClassMappingDetailListData =
                        await teacherClassMappingDetailListAPI();

                    setTeacherCourseMappingList(
                        teacherClassMappingDetailListData.data
                    );

                    const teacherMappingData =
                        teacherClassMappingDetailListData?.data?.filter(
                            (tfd) =>
                                tfd.teacherId === teacherData.userId &&
                                tfd.schoolId === teacherData.schoollId
                        );

                    console.log(
                        "teacherMappingData >>>>>>> ",
                        teacherMappingData
                    );

                    const uniqueClassesForTeacher = [
                        ...new Set(
                            teacherMappingData.map((tmd) => tmd.className)
                        ),
                    ];

                    setUniqueClassesForTeacher(uniqueClassesForTeacher);

                    console.log(
                        "uniqueClassesForTeacher >>>>>>> ",
                        uniqueClassesForTeacher
                    );

                    console.log(
                        "usablecouselength >>>>>>>>>>>>>>>>>>>>>>>>>",
                        courseMaster?.data?.filter((e) =>
                            uniqueClassesForTeacher?.includes(e.subject)
                        ).length
                    );

                    setUsableCourseLength(
                        courseMaster?.data?.filter((e) =>
                            uniqueClassesForTeacher?.includes(e.subject)
                        ).length
                    );
                } catch (error) {
                    console.error("Error fetching data:", error);
                } finally {
                    setLoading(false);
                }
            }
        };
        fetchMasters();
    }, [loading]);

    useEffect(() => {
        console.log("usableCourseLength >>>>>>>> ", usableCourseLength);
    }, [usableCourseLength]);

    useEffect(() => {
        console.log(
            "teacherCourseMappingList >>>>>>>> ",
            teacherCourseMappingList
        );
    }, [teacherCourseMappingList]);

    useEffect(() => {
        console.log("classCourseMappingList >>>>>>>> ", classCourseMappingList);
    }, [classCourseMappingList]);

    /**
     * Side Effect for the "ClassName Unique List" generation
     */
    useEffect(() => {
        if (userData) {
            setUserClassList([...new Set(userData.map((ud) => ud.className))]);
        }
    }, [userData]);

    /**
     * TESTING PURPOSE ONLY - [ DATA DISPLAY ]
     */
    useEffect(() => {
        console.log("userData ====== ", userData);
        console.log("userClassList ====== ", userClassList);
    }, [userData, userClassList]);

    /**
     * TESTING PURPOSE ONLY - [ DATA DISPLAY ]
     */
    useEffect(() => {
        console.log("courseData ====== ", courseData);
        console.log(
            courseData.filter((e) => e.subject === userData?.className)
        );
    }, [courseData]);

    return (
        <div className="container-scroller">
            <Navbar />
            <div className="container-fluid page-body-wrapper">
                <SideBar />
                <div className="main-panel">
                    <Box
                        sx={{
                            height: "calc(100vh - 60px)",
                            padding: "20px",
                            backgroundColor: "#F8F9FD",
                            overflowY: "scroll",
                            // border: "2px solid red"
                        }}
                    >
                        <Breadcrumb />
                        <Grid2>
                            <Box
                                bgcolor="white"
                                borderRadius="12px"
                                padding="20px"
                            >
                                <Typography variant="h5" marginBottom="10px">
                                    Course List
                                </Typography>
                                <Divider />
                                <Stack spacing={2} marginTop="20px">
                                    <Grid2 container spacing={2}>
                                        {usableCourseLength === 0 &&
                                        courseData === null ? (
                                            <Typography
                                                variant="subtitle1"
                                                color="secondary"
                                            >
                                                No Course Data Available
                                            </Typography>
                                        ) : courseData?.length > 0 ? (
                                            courseData
                                                .filter((e) =>
                                                    uniqueClassesForTeacher?.includes(
                                                        e.subject
                                                    )
                                                )
                                                .filter(
                                                    (course, idx, slf) =>
                                                        idx ===
                                                        slf.findIndex(
                                                            (c) =>
                                                                c.courseName ===
                                                                course.courseName
                                                        )
                                                )
                                                .map((course, index) => (
                                                    <Grid2
                                                        sx={{
                                                            cursor: "pointer",
                                                        }}
                                                        size={8}
                                                        container
                                                        direction="row"
                                                        padding="10px"
                                                        border="1px solid #F3F0EC"
                                                        borderRadius="6px"
                                                        height="195px"
                                                        key={index}
                                                        onClick={() =>
                                                            setCourseInternalData(
                                                                course
                                                            )
                                                        }
                                                    >
                                                        <Grid2 size={3}>
                                                            <img
                                                                style={{
                                                                    height: "100%",
                                                                    width: "100%",
                                                                    maxHeight:
                                                                        "173px",
                                                                    maxWidth:
                                                                        "250px",
                                                                    objectFit:
                                                                        "cover",
                                                                    borderRadius:
                                                                        "6px",
                                                                    objectPosition:
                                                                        "top",
                                                                }}
                                                                src={
                                                                    API_courseURL +
                                                                    course?.courseThumbnailImagepath
                                                                }
                                                                alt={
                                                                    course.courseName
                                                                }
                                                            />
                                                        </Grid2>
                                                        <Grid2 size={9}>
                                                            <Typography variant="h5">
                                                                {
                                                                    course.courseName
                                                                }
                                                            </Typography>
                                                            <Typography variant="caption">
                                                                {
                                                                    course.courseCode
                                                                }
                                                            </Typography>
                                                        </Grid2>
                                                    </Grid2>
                                                ))
                                        ) : (
                                            "null"
                                        )}
                                    </Grid2>
                                </Stack>
                            </Box>
                        </Grid2>
                    </Box>
                    <Snackbar
                        open={snackbarOpen}
                        autoHideDuration={6000}
                        onClose={() => setSnackbarOpen(false)}
                    >
                        <MuiAlert
                            onClose={() => setSnackbarOpen(false)}
                            severity="error"
                            sx={{ width: "100%" }}
                        >
                            Add your Parent Information
                        </MuiAlert>
                    </Snackbar>
                </div>
            </div>
        </div>
    );
};

export default CourseList;
